<template>
  <div class="course-selection-detail">
    <div class="my-page-head">
      <el-page-header :content="pageTitle" @back="goBack" />
      <ul class="page-head-ul">
        <li v-for="(item, index) in pageHeaderArr" :key="item.title + index">
          <label>{{ item.title }}:</label>
          <span>{{ item.value }}</span>
        </li>
      </ul>
    </div>

    <ming-table v-model="selectionData" v-loading="isLoading" :fields="tableColumn">
      <template #courseDesc="{ scope }">
        <el-button type="text" :disabled="!scope.courseFile" @click="watchIntroduction(scope)">查看</el-button>
      </template>
      <template #deanClass="{ scope }">
        <div v-for="el in scope.deanClass" :key="el">{{ el.title }}</div>
        <span v-if="scope.deanClass.length == 0">{{ scope.other_keyword }}</span>
      </template>
      <template #teachers="{ scope }">
        <div v-for="el in scope.teachers" :key="el">{{ el.name }}</div>
      </template>
      <template #courseStartWeeknum="{ scope }"> {{ scope.courseStartWeeknum }} ~ {{ scope.courseEndWeeknum }} </template>
      <template #weeks="{ scope }">
        <small v-for="el in scope.timeDesc" :key="el"> {{ el }} <br /></small>
      </template>
      <template #batchNum="{ scope }"> {{ scope.rankingNum }} / {{ scope.batchNum }} </template>
      <!-- batchNum -->
      <template #options="{ scope }">
        <el-button v-if="!scope.batchState" type="text" :style="!ctids.includes(scope.ctid) ? 'color:#67C23A' : ''" @click="selectChange(scope)">{{
          ctids.includes(scope.ctid) ? '取消选择' : '选择'
        }}</el-button>
      </template>
    </ming-table>

    <course-introduction :visible.sync="introductionVisible" :content="introduction" :course-file="courseFile" />
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import API from '@/api'
import Router from '@/router'
import { SelectionDetailTableColumn2 } from './tableConfig'
import CourseIntroduction from './components/CourseIntroduction.vue'
const pageTitle = ref('选课详情（已选）')
const pageHeaderArr = ref([
  {
    title: '学年',
    value: '-'
  },
  {
    title: '学期',
    value: '-'
  },
  {
    title: '授课教师',
    value: '-'
  }
])
const route = Router.currentRoute

const tableColumn = ref(SelectionDetailTableColumn2)

// const TableColumn = ref()
/* 获取当前学年、学期、周数 */
function getSchoolCalendar() {
  API.Semester().then(res => {
    if (+res.code === 200) {
      const { semester, schoolYear, week } = res.data
      const data = [
        {
          title: '学年',
          value: schoolYear || '-'
        },
        {
          title: '学期',
          value: semester || '-'
        },
        {
          title: '教学周',
          value: week ? `第${week}周` : '-'
        }
      ]
      pageHeaderArr.value = data
    }
  })
}

//
const introductionVisible = ref(false)
const introduction = ref()
const courseFile = ref()
function watchIntroduction(item) {
  window.open((process.env.VUE_APP_GATEWAY || '') + item.courseFile, '_blank')
  // introduction.value = item.courseDesc || '暂无内容'
  // courseFile.value = item.courseFile
  // introductionVisible.value = true
}
// 返回
function goBack() {
  Router.go(-1)
}
const ctids = ref([])
const isLoading = ref(false)

const studentConfig = ref({})
const selectionData = ref([])
function getSelectionData() {
  ctids.value = []
  API.primaryCourseList(params).then(res => {
    if (+res.code === 200) {
      studentConfig.value = {
        ...res.data.studentConfig,
        studentSelectedCredit: res.data.studentSelectedCredit,
        studentSlectedCourseNum: res.data.studentSlectedCourseNum,
        studentUnselectCredit: res.data.studentUnselectCredit,
        remark: res.data.remark
      }

      res.data.list.forEach(el => {
        if (el.batchState > 0) {
          selectionData.value.push(el)
        }
      })
    }
    isLoading.value = false
  })
}

const params = reactive({
  tabType: route.query.type,
  'ChooseBatchCourseSearch[batch_id]': route.query.id,
  selectedCourse: 1
})
onMounted(() => {
  getSchoolCalendar()
  getSelectionData()
})
</script>

<style lang="scss" scoped>
.course-selection-detail {
	width: 100%;
	height: 100%;
	background-color: #fff;
	box-sizing: border-box;
	padding: 20px;
	border-radius: 8px;
	overflow: hidden;

	.desc {
		h6,
		p {
			font-size: 16px;
			color: #666666;
		}
	}

	.btns {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;

		.el-button {
			width: 140px;
		}
	}
}

.my-page-head {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 10px;
	border-bottom: 1px solid #ddd;
	margin-bottom: 20px;
}

ul.page-head-ul {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	margin: 0;
	padding: 0;

	li {
		list-style: none;

		label {
			font-size: 16px;
			color: #777;
			margin-right: 10px;
		}

		span {
			font-size: 16px;
			color: #333;
		}

		&:not(:last-child) {
			margin-right: 60px;
		}
	}
}
</style>
